import React, { useState, useEffect } from 'react';
import { Download, ArrowRight, Check, Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const Catalogo = () => {
  const [catalogUrl, setCatalogUrl] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCatalogUrl = async () => {
      try {
        const resp = await fetch(`${API_URL}/api/catalogo/url`);
        if (resp.ok) {
          const data = await resp.json();
          let url = data.url || '';
          if (url.startsWith('/api/files/')) {
            url = `${API_URL}${url}`;
          }
          setCatalogUrl(url);
        }
      } catch (err) {
        console.error('Erro ao carregar URL do catálogo:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchCatalogUrl();
  }, []);

  const beneficios = [
    'Zero custo de preparação - basta aquecer e servir.',
    'Zero desperdício - pesos e rendimentos controlados.',
    'Serviço rápido - pratos prontos em 3-6 minutos.',
    'Sabor consistente todos os dias - processo padronizado e artesanal.',
    'Lucro previsível - embalagens com custo/dose e rendimento real.',
    'Validade prolongada e segurança alimentar - vacuum + choque térmico.',
    'Fabrico local em Mafra - produção artesanal e controlo total de qualidade.',
    'Perfeito para qualquer negócio - restaurantes, cafés, hotéis, eventos, food trucks e mercearias.'
  ];

  const getViewUrl = () => {
    if (!catalogUrl) return '#';
    return catalogUrl;
  };

  const getDownloadUrl = () => {
    return `${API_URL}/api/catalogo/download`;
  };

  return (
    <div className="min-h-screen bg-[#1a1a1a] pt-20">
      <section className="relative h-[40vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 z-0 bg-gradient-to-b from-[#242424] to-[#1a1a1a]" />
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 z-10 text-center">
          <p className="text-[#B8860B] text-sm tracking-[0.3em] uppercase mb-4">Download</p>
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-semibold text-[#E8DDCB] mb-6" style={{fontFamily: "'Playfair Display', serif"}}>
            Catálogo
          </h1>
          <div className="w-16 h-[2px] bg-[#B8860B] mx-auto" />
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl">
          <h2 className="text-2xl sm:text-3xl font-semibold text-[#E8DDCB] text-center mb-12" style={{fontFamily: "'Playfair Display', serif"}}>
            Porquê escolher Santa Carne?
          </h2>
          <div className="space-y-4">
            {beneficios.map((b, i) => (
              <div key={i} className="flex items-start space-x-3 p-4 rounded-lg bg-[#242424]/60 border border-[#B8860B]/10">
                <Check className="w-5 h-5 text-[#B8860B] mt-0.5 flex-shrink-0" />
                <p className="text-[#E8DDCB]/80 text-sm leading-relaxed">{b}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 border-t border-[#B8860B]/10">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center max-w-2xl">
          <div className="w-16 h-16 rounded-full bg-[#B8860B]/10 flex items-center justify-center mx-auto mb-6">
            <Download className="w-8 h-8 text-[#B8860B]" />
          </div>
          <h2 className="text-3xl sm:text-4xl font-semibold text-[#E8DDCB] mb-4" style={{fontFamily: "'Playfair Display', serif"}}>
            Catálogo 2025
          </h2>
          <p className="text-[#E8DDCB]/60 text-base mb-8">
            Veja o nosso catálogo completo com todos os produtos e informações.
          </p>

          {loading ? (
            <div className="flex items-center justify-center py-4">
              <Loader2 className="w-6 h-6 text-[#B8860B] animate-spin" />
            </div>
          ) : (
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href={getViewUrl()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="view-catalog-btn"
                className="inline-flex items-center justify-center bg-[#B8860B] hover:bg-[#D4A84B] text-[#1a1a1a] font-semibold tracking-wider uppercase text-sm px-10 py-4 rounded-md transition-colors w-full sm:w-auto max-w-xs"
              >
                <Download className="mr-2 w-5 h-5" />
                Ver Catálogo
              </a>

              <a
                href={getDownloadUrl()}
                data-testid="download-pdf-btn"
                className="inline-flex items-center justify-center border-2 border-[#B8860B] text-[#B8860B] hover:bg-[#B8860B]/10 font-semibold tracking-wider uppercase text-sm px-10 py-4 rounded-md transition-colors w-full sm:w-auto max-w-xs"
              >
                Guardar PDF
              </a>
            </div>
          )}

          <div className="mt-12 flex items-center justify-center text-[#B8860B]">
            <a href="/contacto" className="flex items-center space-x-2 hover:text-[#D4A84B] transition-colors">
              <span className="text-sm font-medium tracking-wider uppercase">Fale connosco</span>
              <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Catalogo;
